/* @ngInject */
export default function tokenInteceptorFactory(tokenService) {
  return {
    request: function(config) {
      if (tokenService.getToken() !== null && !config.ignoreTokenInterceptor) {
        config.headers['Authorization'] = 'Bearer '+ tokenService.getToken();
      }
      return config;
    }
  };
}



// WEBPACK FOOTER //
// ./src/interceptors/token.interceptor.js